import React from 'react';
import { Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <img 
              src={process.env.REACT_APP_NORTH_BRIDGE_LOGO} 
              alt="North Bridge" 
              className="footer-logo"
            />
            <p className="footer-tagline">Engineering the Future of Climate & Energy</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Solutions</h4>
              <ul>
                <li><a href="#solutions">HVAC Systems</a></li>
                <li><a href="#solutions">Heat Pumps</a></li>
                <li><a href="#solutions">Renewable Energy</a></li>
                <li><a href="#solutions">Pool Climate Systems</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About Us</a></li>
                <li><a href="#solutions">Our Brands</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact</h4>
              <ul>
                <li>
                  <Mail size={16} />
                  <a href="mailto:info@northbridge.uk">info@northbridge.uk</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} North Bridge UK. All rights reserved.</p>
          <div className="footer-brands">
            <span>Welliston</span>
            <span>Danford</span>
            <span>Lorenza</span>
          </div>
        </div>
      </div>
    </footer>
  );
};